export default __webpack_public_path__ + "static/media/AutomationTasks.684db874.svg";